﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs, eBundle } from "@app/helpers/dirs";
import { eValidationType, IValidationMessage } from "@models";

export interface IValidationMessagesScope extends ng.IScope {
    ngModel: IValidationMessage[];
    messageClicked: (msg: IValidationMessage) => void;
    hideAutoValidation: boolean;
    autoValidation: boolean;

    _toggleAutoValidation: () => void;
    _getTitle: () => string;
}

/**
 * For showing validation messages of a configurator
 */
@NgComponent({
    token: Token.KbValidationMessages
})
export class KbValidationMessages extends Directive {
    constructor() {
        super();

        this.restrict = "EA";
        this.template = Dirs.component("kb-validation-messages", eBundle.app);
        this.scope = {
            ngModel: "=?",
            messageClicked: "&",
            hideAutoValidation: "=?",
            autoValidation: "=?"
        };
        this.replace = true;
        this.link = (scope: IValidationMessagesScope, element, atts) => {
            scope._toggleAutoValidation = () => {
                scope.autoValidation = !scope.autoValidation;
            };

            scope._getTitle = () => {
                let title: string = "";
                if (!scope.ngModel || scope.ngModel.length == 0) {
                    title = loc.noerrors;
                } else {
                    let errors = scope.ngModel.filter(m => m.messageType == eValidationType.error);
                    let warnings = scope.ngModel.filter(m => m.messageType == eValidationType.warning);
                    if (errors.length) {
                        title += errors.length + " " + (errors.length > 1 ? loc.errors : loc.error);
                    }
                    if (errors.length && warnings.length) {
                        title += " / ";
                    }
                    if (warnings.length) {
                        title += warnings.length + " " + (warnings.length > 1 ? loc.warnings : loc.warning);
                    }
                }
                return title;
            };
        };
    }
}
